// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wrap-1YfwvUdG","nav":"nav-3vr7XY5a clearfix","list":"list-i87K_WpA"};